/**
 * Socket Utilities
 * Socket data encoding/decoding functions
 */

/**
 * Encode data for socket (Blob)
 * @param {*} data
 * @returns {Blob}
 */
export function encode(data) {
  try {
    return new Blob([JSON.stringify(data)]);
  } catch (e) {
    console.error('Error encoding data:', e);
    return data;
  }
}

/**
 * Decode data from socket (ArrayBuffer)
 * Exactly like old working code
 * @param {ArrayBuffer} data
 * @returns {*}
 */
export function decode(data) {
  try {
    var responseData = new TextDecoder().decode(data);
    return JSON.parse(responseData);
  } catch (e) {
    console.error('Error decoding data:', e, 'Data type:', typeof data, 'Is ArrayBuffer:', data instanceof ArrayBuffer, 'Data:', data);
    return null;
  }
}
